<template>
  <div>

    <v-container fluid>



      Server offline for scheduled maintenance. TaskTeacher be back online soon.


    </v-container>
  </div>
</template>
<script>
   export default {
      data() {
         return {

         };
      }
   };
</script>
